import { render } from "./IconBoldArrowRight.vue?vue&type=template&id=1e5ddb16"
import script from "./IconBoldArrowRight.vue?vue&type=script&lang=js"
export * from "./IconBoldArrowRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconBoldArrowRight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e5ddb16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e5ddb16', __exports__)) {
    api.reload('1e5ddb16', __exports__)
  }
  
  module.hot.accept("./IconBoldArrowRight.vue?vue&type=template&id=1e5ddb16", () => {
    api.rerender('1e5ddb16', render)
  })

}


export default __exports__